export enum GlobalEvents {
  MSG_SUCCESS = 'global-msg-success',
  MSG_ERROR = 'global-msg-error',
  PRINT_TRX_RECEIPT = 'ico_share_android-event',
}
